import { Type } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";
import { OptionalOrNull } from "../shared-schemas";

const recordingModeType = Type.Union([Type.Literal("off"), Type.Literal("normal"), Type.Literal("strict")]);

export const proctoringOptionsType = Type.Object({
	enforceLockdown: Type.Boolean(),
	enforceMobile: Type.Boolean(),
	isExtension: Type.Boolean(),
	isLockdown: Type.Boolean(),
	isMobile: Type.Boolean(),
	videoRecordingMode: recordingModeType,
	audioRecordingMode: recordingModeType,
	recordScreen: Type.Boolean(),
	recordWebTraffic: Type.Boolean(),
	excludedWebTrafficRecordingUrls: OptionalOrNull(Type.Array(Type.String())),
	recordClipboard: Type.Boolean(),
	recordInput: Type.Boolean(),
	oneScreenEnforcementMode: recordingModeType,
	disableNewTab: Type.Boolean(),
	closeOpenTabs: Type.Boolean(),
	tabWhiteList: OptionalOrNull(Type.Array(Type.String())),
	tabBlockList: OptionalOrNull(Type.Array(Type.String())),
	keyboardShortcutBlockList: OptionalOrNull(Type.Array(Type.String())),
	disableClipboardMode: Type.Union([Type.Literal("off"), Type.Literal("tab"), Type.Literal("system")]),
	enableGuidedAccessMode: Type.Boolean(),
	disableSpellcheck: Type.Boolean(),
	disablePrinting: Type.Boolean(),
	disableRightClick: Type.Boolean(),
	disableDownloadFiles: Type.Boolean(),
	hideOtherWindows: Type.Boolean(),
	showRecordingPanel: Type.Boolean(),
	idVerification: Type.Boolean(),
	idVerificationEnableAi: Type.Boolean(),
	faceTrackingMode: recordingModeType,
	objectDetectionMode: recordingModeType,
	applicationBlockMode: recordingModeType,
	applicationBlockList: OptionalOrNull(Type.Array(Type.String())),
	blockVirtualMachines: Type.Boolean(),
	recordApplicationsActivity: Type.Boolean(),
	isLiveProctored: Type.Boolean(),
	isLivePopIn: Type.Boolean(),
	enablePostReview: Type.Boolean(),
	scanRoom: Type.Boolean(),
	quietEnvironment: Type.Boolean(),
	enableCalculator: Type.Union([Type.Literal("off"), Type.Literal("scientific"), Type.Literal("standard")]),
	enableWhiteboard: Type.Boolean(),
	uploadScratchNotes: Type.Boolean(),
	idVerificationMode: recordingModeType,
	restrictDevices: Type.Boolean(),
});

const verityOptions = new SchemaValidator(
	Type.Object({
		...proctoringOptionsType.properties,
		enabled: Type.Boolean(),
		requiresIncognito: Type.Boolean(),
		logEvents: Type.Boolean(),
		password: OptionalOrNull(Type.String()),
		thirdPartyAssessmentOptions: OptionalOrNull(
			Type.Object({
				thirdPartyUrl: OptionalOrNull(Type.String()),
				password: OptionalOrNull(Type.String()),
				thirdPartyPlatformId: OptionalOrNull(Type.Number()),
			}),
		),
	}),
);

const applicationResponse = new SchemaValidator(
	Type.Array(
		Type.Object({
			id: Type.Number(),
			name: Type.String(),
			processName: Type.Array(Type.String()),
			iconSvg: Type.String(),
			type: Type.Union([
				Type.Literal("Browser"),
				Type.Literal("Communication"),
				Type.Literal("Screen Sharing"),
				Type.Literal("Other"),
			]),
			createdAt: Type.String(),
			updatedAt: Type.String(),
		}),
	),
);

export default {
	verityOptions,
	applicationResponse,
};
